import { Text } from "atoms";
import React from "react";

export const PageHeading = ({ text, ...props }) => {
  return (
    <Text
      as="h1"
      fontSize="2.4rem"
      color="primary.900"
      firstLetterCapital
      fontFamily="NeometricBold"
      borderBottom="1px solid"
      borderColor="neutral.100"
      pb="1.6rem"
      {...props}
    >
      {text}
    </Text>
  );
};
